/* eslint-disable no-undef */
// import VipCrownIcon from '../images/vip-crown.png'
import TimeFreeIcon from '../images/time-free-icon.png'

const CONFIG = {
  pathModules: [
    {
      path: '/photo/location',
      title: '照片地点',
      iconImg: TimeFreeIcon,
      iconFont: 'iconzhaopiandidian1'
    },
    {
      path: '/member/location',
      title: '人员实时定位',
      iconImg: TimeFreeIcon,
      iconFont: 'iconzhaopiandidian1'
    },
    {
      path: '/ai-classify',
      title: '分类文件夹',
      iconFont: 'iconwenjianjiaicon1'
    },
    {
      title: '客户管理',
      iconFont: 'iconkehubaifangtongji',
      path: '/customer',
      children: [
        {
          path: '/visit/record',
          title: '拜访记录'
        },
        {
          path: '/customer/info',
          title: '客户信息'
        }
      ]
    },
    {
      path: '/pathway',
      title: '拍照路线',
      iconFont: 'iconpaizhaoluxian'
    },
    {
      path: '/team',
      title: '团队管理',
      iconFont: 'icontuanduiguanli1',
      children: [
        {
          path: '/team/department',
          title: '成员/部门管理'
        },
        {
          path: '/team/admin',
          title: '管理员设置'
        },
        {
          path: '/team/log',
          title: '操作日志'
        }
      ]
    },
    {
      path: '/attendance',
      title: '考勤统计',
      iconFont: 'iconkaoqintongji1',
      children: [
        {
          path: '/attendance/daily',
          title: '每日统计'
        },
        {
          path: '/attendance/period',
          title: '周月统计'
        },
        {
          path: '/attendance/ruleset',
          title: '考勤规则设置'
        }
      ]
    },
    {
      path: '/watermark/data',
      title: '照片台账表',
      iconFont: 'iconshuiyinshuju1',
      new: true
    },
    {
      path: '/watermark/list',
      title: '水印管理',
      iconFont: 'iconshuiyinguanli1'
    },
    {
      path: '/authority',
      title: '权限管理',
      iconFont: 'iconquanxianguanli'
    },
    {
      path: '/userManual',
      title: '使用手册',
      iconFont: 'iconmanual1'
    },
    {
      path: '/qa',
      title: '联系客服',
      iconFont: 'iconlianxikefu'
    }
  ],

  maxDownloadNum: 5000,

  searchMaxDownloadNum: 5000,

  directDownloadLimit: 2000,

  freeDownloadLimit: 1000,

  maxDownloadLimit: 20000,

  photoWatermarksMaxDownloadLimit: 50000,

  timeFormat: 'YYYY-MM-DD HH:mm:ss',

  minuteFormat: 'YYYY-MM-DD HH:mm',

  dateFormat: 'YYYY-MM-DD',

  timeFormatWithoutDate: 'HH:mm:ss',

  monthFormat: 'MMM',

  dayFormat: 'Do',

  yearFormat: 'YYYY',

  hourMinuteFormat: 'HH:mm',

  monthFormatZH: 'YYYY年MM月',

  dateFormatZH: 'YYYY年MM月DD日',

  dateTimeFormatZH: 'YYYY年MM月DD日 HH时mm分ss秒',

  photoTimeThisYearFormat: 'MM月DD日 HH:mm',

  photoTimeFormat: 'YYYY年MM月DD日 HH:mm',

  photoNamingTimeFormat: 'YYYY-MM-DD HH_mm_ss',

  memberRoles: [
    {
      id: -1,
      role: '全部成员'
    },
    {
      id: 0,
      role: '普通成员'
    },
    {
      id: 1,
      role: '主管理员'
    },
    {
      id: 2,
      role: '管理员'
    },
    {
      id: 3,
      role: '部门管理员'
    }
  ],

  groupVipType: {
    0: '普通包月',
    1: '普通包年',
    2: '订阅包月',
    3: '订阅包年'
  },

  memberRoleTypes: {
    ALL: -1,
    NORMAL: 0,
    ADMIN: 2,
    MASTER_ADMIN: 1,
    DEPARTMENT_ADMIN: 3
  },

  viewPermissionTypes: {
    GROUP: 0,
    PERSONAL: 1,
    DEPARTMENT: 2
  },

  memberStatus: {
    INACTIVE: -2, //未激活
    NORMAL: 1,
    QUITED: 2,
    WRITTENOFF: 3
  },

  attendanceTypes: [
    {
      id: 1,
      label: '考勤详情'
    },
    {
      id: 2,
      label: '考勤汇总'
    }
  ],

  PHOTO_PAGE_LIMIT: 50,

  photoPrefix: 'https://net-cloud.xhey.top/group/photo/',
  tencentPhotoPrefix: 'https://net-cloud-tx.xhey.top/group/photo/',

  memberExcelUrl:
    'https://static.xhey.top/%E4%BB%8A%E6%97%A5%E6%B0%B4%E5%8D%B0%E7%9B%B8%E6%9C%BA-%E9%80%9A%E8%AE%AF%E5%BD%95%E6%A8%A1%E6%9D%BF.xlsx',
  // 客户地点模板-自主导入模版
  customInfoExcelUrl:
    'https://static.xhey.top/%E5%AE%A2%E6%88%B7%E5%9C%B0%E7%82%B9%E6%A8%A1%E6%9D%BF-%E8%87%AA%E4%B8%BB%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
  // 客户地点模板-含经纬度
  anotherCustomInfoExcelUrl:
    'https://static.xhey.top/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',

  geoDataExcelUrl:
    'https://static.xhey.top/%E6%89%B9%E9%87%8F%E6%B7%BB%E5%8A%A0%E9%80%89%E9%A1%B9%E6%A8%A1%E6%9D%BF.xlsx',

  cascadeItemListExcelUrl:
    'https://static.xhey.top/%E5%A4%9A%E7%BA%A7%E9%80%89%E9%A1%B9%E5%86%85%E5%AE%B9%E6%A8%A1%E6%9D%BF.xlsx',

  orgStructureExcelUrl:
    'https://static.xhey.top/%E7%BB%84%E7%BB%87%E6%9E%B6%E6%9E%84%E6%88%90%E5%91%98%E5%AF%BC%E5%85%A5.xlsx',

  mobileRegex: /^[1]([3-9])[0-9]{9}$/,

  ossImgProcessThumb: '?x-oss-process=image/resize,w_250',
  ossImgProcess500: '?x-oss-process=style/thumb500',
  ossImgProcess600: '?x-oss-process=style/w_600',
  ossImgProcess900: '?x-oss-process=style/w_900',
  ossImgCompressOriginal: '?x-oss-process=style/compress_original',

  pathwayColors: [
    '#C03A31',
    '#126197',
    '#008E9C',
    '#A71D81',
    '#D19619',
    '#FAC671',
    '#029A6A',
    '#8FC123',
    '#029BC1',
    '#F6E62C',
    '#D6A6A1',
    '#E45F23',
    '#77A22F',
    '#6A367D',
    '#DC82B3',
    '#E42777',
    '#E45F23',
    '#A499BC',
    '#B25B20',
    '#4AAD54'
  ],

  pathwayPanelTypes: {
    SHOT_PANEL: 'SHOT',
    NOT_SHOT_PANEL: 'NOT_SHOT'
  },

  albumTypes: {
    ALBUM: 2,
    WATERMARK: 3,
    FAVORITE: 4,
    WATERMARKS: 100
  },

  onlyInGroup: {
    UNKNOW: 0,
    ALL: 1,
    ONLY_IN_GROUP: 2
  },

  saKeywords: {
    roles: {
      1: 'chiefManager',
      2: 'manager',
      3: 'departmentManager',
      0: 'member'
    },
    fileTypes: {
      0: 'photo',
      1: 'video'
    },
    sourceTypes: {
      0: 'todayCam',
      1: 'notTodayCam',
      2: 'notSelfTake',
      3: 'notCurrentPhoneTake'
    }
  },

  sourceTypesTips: {
    1: '非今日水印相机拍摄，不确保时间地点真实',
    2: '非本人拍摄',
    3: '非成员常用手机拍摄'
  },

  baseID: [
    {
      id: '1',
      name: '小时刻水印'
    },
    {
      id: '2',
      name: '纯时间水印'
    },
    {
      id: '3',
      name: '日期地点水印'
    },
    {
      id: '7',
      name: '星期水印'
    },
    {
      id: '8',
      name: '纯日期水印'
    },
    {
      id: '10',
      name: '自定义水印'
    },
    {
      id: '14',
      name: '自定义标题'
    },
    {
      id: '20',
      name: '工程水印'
    },
    {
      id: '21',
      name: '考勤打卡'
    },
    {
      id: '23',
      name: '会议记录水印'
    },
    {
      id: '24',
      name: '大时刻水印'
    },
    {
      id: '25',
      name: '微店水印'
    },
    {
      id: '27',
      name: '秒表水印'
    },
    {
      id: '33',
      name: '中号时刻水印'
    },
    {
      id: '34',
      name: '时间地点天气'
    },
    {
      id: '35',
      name: '亓道经纬水印'
    },
    {
      id: '43',
      name: '执勤水印'
    },
    {
      id: '44',
      name: '电网水印'
    },
    {
      id: '45',
      name: '疫情防控水印'
    },
    {
      id: '46',
      name: '品牌水印'
    },
    {
      id: '47',
      name: '电子时钟水印'
    },
    {
      id: '48',
      name: '红色图钉水印'
    },
    {
      id: '49',
      name: '经纬度水印'
    },
    {
      id: '50',
      name: '民情日记水印'
    },
    {
      id: '51',
      name: '网格化管理'
    },
    {
      id: '52',
      name: '自动识别车牌号'
    },
    {
      id: '53',
      name: '名片水印'
    },
    {
      id: '54',
      name: '自动识别人数'
    },
    {
      id: '55',
      name: '物业水印'
    },
    {
      id: '56',
      name: '环卫水印'
    },
    {
      id: '10000',
      name: '无水印（ios）'
    },
    {
      id: '-1',
      name: '无水印（安卓）'
    }
  ],

  folderConfig: {
    noVipLimit: 10,
    vipLimit: 500,
    maxLevel: 10,
    maxCutPhotoLimit: 500,
    maxCutFolderLimit: 50,
    maxDeleteFolderLimit: 50,
    folderMaxPhotosLimit: 30000,
    folderMaxPhotosLimitStr: '3万',
    batchAddPhotoLimit: 2000
  },

  VIP_KIND: {
    VIP: 1,
    SVIP: 2,
    VVIP: 3,
    EVIP: 4
  },

  nomalGroupDatesLimit: 90,

  jigsawMaxNum: 21,

  vipPrivilege: {
    watermarkNum: {
      noVip: 1,
      vip: 8
    },
    adminNum: {
      noVip: 2,
      vip: 5
    }
  },

  // 高德开发者key
  GAODE_KEY: '348f768eed5b34b13c44ebccc532b7a6',

  DESKTOP_DOWNLOAD_URL: __DESKTOP_DOWNLOAD_URL__,
  // 拉取 key-value 配置，请求参数，统一维护
  KVParams: {
    names: [
      'normal_group_data_limit_days',
      'required_field_clear_time',
      'normal_group_option_limit',
      'udesk_enable',
      'num_of_batch_verfication',
      'oss_service_config',
      'live_streaming_config',
      'photo_book_limit',
      'web_watermark_switch',
      'web_credit_switch',
      'team_member_oversize_call_Phone',
      'todayclaw_entry_config',
      'todayclaw_beta_short_ids',
      'batch_watermark_apply_scope_ui_v2',
      // 'photo_label_enabled_group_ids' / 'photo_label_enabled_group_ids_server' 已不再使用：
      //   照片标签灰度判断从"前端读 KV 本地比对"切到后端接口 /web/workgroup/photo/label/whitelist/check。
      //   数据源由 KV 迁到 photo_label_whitelist 表（2026-05-29）。
      'photo_label_team_group_limit',
      // 'ai_folder_classify_group' / 'ai_folder_classify_group_suffix' 已移除：
      //   AI 智能分类已全量上线，入口固定为新版，不再读 KV 做团队白名单判定（2026-06-18）。
      //   保留此注释作为变更记录，一段时间后清除。
      'AI_form_filling_edit_tools', // AI 填表员「文档编辑工具」列表（默认 excel_edit/word_edit），解析见 aiClerk/utils/editTools.ts
      // 'ai_form_filling_time_ab' 已废弃(2026-07-22)：时间 A/B 全量收口为配置卡+智能直发，前端不再读。
      // AI 填表员首页布局实验已于 2026-07-24 全量，相关 KV 不再读取。
      'workspace_inspection_config', // 巡检模块配置
      'web_ai_points_pack', // 积分包 PointsPackModal
      'web_points_status_card' // 积分状态卡 PointsStatusCard
    ]
  },

  // 客服电话
  CUSTOMER_PHONE: '400 6052 366'
}

export default CONFIG
